import { createModuleLayout } from "@/lib/create-module-layout";
import { MODULES } from "@kubdee/shared/module-ids";
import dormitoryModule from "@kubdee/module-dormitory";

export default createModuleLayout({
  moduleId: MODULES.DORMITORY,
  moduleConfig: dormitoryModule,
  sidebarInsetClassName: "flex flex-col h-svh min-w-0 overflow-hidden bg-background",
});
